import { Auth0Buttons } from '~/app/components/auth0-buttons/auth0-buttons';
import SegmentImpression from '~/app/components/segment-impression';
import { useDynamicAnalytics } from '../../segment/use-dynamic-analytics';
import {
  SegmentTrackingProps,
  SegmentTrackingForm,
} from '../../segment/segment-tracking-form';

type DynamicAuthButtonProps = {
  segment?: SegmentTrackingProps;
};

export const DynamicAuthButton = ({ segment }: DynamicAuthButtonProps) => {
  const { impressionViewProps } = useDynamicAnalytics({
    entityName: segment?.entityName || '',
    impressionSection: segment?.impressionSection || '',
    impressionPosition: segment?.impressionPosition || '',
    enableInteractionTracking: segment?.enableInteractionTracking || false,
  });
  return (
    <SegmentImpression
      eventName="Auth Button Viewed"
      eventProps={impressionViewProps}
    >
      <Auth0Buttons.Container>
        <Auth0Buttons.AppleButton />
        <Auth0Buttons.GoogleButton />
        <Auth0Buttons.EmailLink />
        <Auth0Buttons.LegalLinks />
      </Auth0Buttons.Container>
    </SegmentImpression>
  );
};

export const DynamicAuthButtonForm = () => {
  return (
    <div>
      <SegmentTrackingForm />
    </div>
  );
};
